/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.string.starts-with.js";
//
//
//
//
//
//
export default {
  name: 'CircleImg',
  props: {
    imgSrc: String,
    defaultImgSrc: String,
    imgWidth: String,
    border: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      styleObject: {
        width: this.imgWidth,
        height: this.imgWidth
      }
    };
  },
  computed: {
    src: function src() {
      if (this.imgSrc) {
        return this.imgSrc.startsWith('http') || this.imgSrc.startsWith('data:image') ? this.imgSrc : Cons.ENV_SH_IMGROOT_PATH + this.imgSrc;
      } else {
        return this.imgSrc;
      }
    }
  },
  created: function created() {}
};